import type { OpportunityStatus } from '@ps/isp-web-services-types';
import { RunnerStatusMarketDetails } from '@ps/isp-web-services-types';

export const runnerStatusMap: Record<OpportunityStatus, RunnerStatusMarketDetails> = {
  AVAILABLE: RunnerStatusMarketDetails.ACTIVE,
  RESTRICTED: RunnerStatusMarketDetails.ACTIVE,
  SUSPENDED: RunnerStatusMarketDetails.SUSPENDED,
  UNAVAILABLE: RunnerStatusMarketDetails.REMOVED
};
